import { useEffect, useState } from 'react'
import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

const AnimatedNumber = ({ value, suffix = '' }) => {
  const [count, setCount] = useState(0)
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })

  useEffect(() => {
    if (isInView) {
      let start = 0
      const end = parseInt(value)
      const duration = 2000
      const increment = end / (duration / 16)

      const timer = setInterval(() => {
        start += increment
        if (start > end) {
          setCount(end)
          clearInterval(timer)
        } else {
          setCount(Math.ceil(start))
        }
      }, 16)

      return () => clearInterval(timer)
    }
  }, [isInView, value])

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  )
}

const Stats = () => {
  const { t, i18n } = useTranslation()
  const [stats, setStats] = useState({
    projects: 150,
    clients: 80,
    accuracy: 99.5,
    years: 5,
  })

  useEffect(() => {
    // 获取统计数据
    axios.get('/api/stats')
      .then(response => {
        setStats(response.data)
      })
      .catch(error => {
        console.error('Failed to fetch stats:', error)
      })
  }, [])

  const statsData = [
    {
      value: stats.projects,
      suffix: '+',
      label: t('stats.projects'),
      color: 'from-blue-500 to-cyan-500',
    },
    {
      value: stats.clients,
      suffix: '+',
      label: t('stats.clients'),
      color: 'from-purple-500 to-pink-500',
    },
    {
      value: stats.accuracy,
      suffix: '%',
      label: t('stats.accuracy'),
      color: 'from-green-500 to-teal-500',
    },
    {
      value: stats.years,
      suffix: i18n.language === 'zh' ? '年' : '+',
      label: t('stats.industries'),
      color: 'from-orange-500 to-red-500',
    },
  ]

  return (
    <section className="py-20 relative overflow-hidden tech-bg">
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            用数据说话
          </h2>
          <p className="text-xl text-gray-300">
            持续为客户创造价值，用实力赢得信赖
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className={`text-5xl md:text-6xl font-bold bg-gradient-to-r ${stat.color} bg-clip-text text-transparent mb-4`}>
                <AnimatedNumber value={stat.value} suffix={stat.suffix} />
              </div>
              <div className="text-gray-300 text-lg">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Stats

